var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createDecipheriv, createCipheriv } from 'crypto';
const algorithm = 'aes-256-cbc';
export const decryptFileWithDecipher = (encryptedData, key, nonce) => __awaiter(void 0, void 0, void 0, function* () {
    const decipher = createDecipheriv(algorithm, Buffer.from(key, 'hex'), Buffer.from(nonce, 'hex'), undefined);
    try {
        const decryptedBuffer = Buffer.concat([
            decipher.update(encryptedData),
            decipher.final(),
        ]);
        return decryptedBuffer;
    }
    catch (error) {
        console.log('Error decrypting the file: ' + error);
        return null;
    }
});
export const encryptFileWithCipher = (fileBuffer, key, nonce, name) => __awaiter(void 0, void 0, void 0, function* () {
    const cipher = createCipheriv(algorithm, Buffer.from(key, 'hex'), Buffer.from(nonce, 'hex'));
    try {
        const encryptedData = Buffer.concat([
            cipher.update(fileBuffer),
            cipher.final(),
        ]);
        return { encryptedData: encryptedData, name: name };
    }
    catch (error) {
        console.log('Error reading or encrypting the file: ' + error);
        return null;
    }
});
export function encryptFileWithCypherStream(key, nonce, readableStream) {
    return __awaiter(this, void 0, void 0, function* () {
        const cipher = createCipheriv(algorithm, Buffer.from(key, 'hex'), Buffer.from(nonce, 'hex'));
        const reader = readableStream.getReader();
        const encryptedStream = new ReadableStream({
            pull(controller) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { done, value } = yield reader.read();
                    // When no more data needs to be consumed, close the stream
                    if (done) {
                        controller.close();
                        return;
                    }
                    // Enqueue the next data chunk into our target stream
                    const encryptedValue = cipher.update(value);
                    controller.enqueue(encryptedValue);
                });
            },
        });
        return new Response(encryptedStream).blob();
    });
}
export function decryptFileWithDecipherStream(key, nonce, readableStream) {
    return __awaiter(this, void 0, void 0, function* () {
        const decipher = createDecipheriv(algorithm, Buffer.from(key, 'hex'), Buffer.from(nonce, 'hex'), undefined);
        const reader = readableStream.getReader();
        const decryptedStream = new ReadableStream({
            pull(controller) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { done, value } = yield reader.read();
                    // When no more data needs to be consumed, close the stream
                    if (done) {
                        controller.close();
                        return;
                    }
                    // Enqueue the next data chunk into our target stream
                    const decryptedValue = decipher.update(value);
                    controller.enqueue(decryptedValue);
                });
            },
        });
        return new Response(decryptedStream).blob();
    });
}
